import { Expose } from "class-transformer";

export class RemoveInvoicesFromCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  invoiceIds: string[];
}
